import { render, staticRenderFns } from "./page07.vue?vue&type=template&id=1529747e&scoped=true&"
import script from "./page07.vue?vue&type=script&lang=js&"
export * from "./page07.vue?vue&type=script&lang=js&"
import style0 from "./page07.vue?vue&type=style&index=0&id=1529747e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1529747e",
  null
  
)

export default component.exports